<template>
  <div>
    <PrimaryButton light dense shrink @click.native="openDialog">
      Edit
      <template v-slot:append:icon>
        <v-icon>mdi-pencil</v-icon>
      </template>
    </PrimaryButton>
    <EditExperienceDialog
      v-if="isOpen"
      :experience="experience"
      :isOpen="isOpen"
      @close="closeDialog"
    />
  </div>
</template>

<script>
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import EditExperienceDialog from "@/views/profile/QuestionsAndAnswers/steps/Experience/dialogs/EditExperienceDialog";

export default {
  name: "EditExperienceAction",
  components: {
    PrimaryButton,
    EditExperienceDialog
  },
  data() {
    return {
      isOpen: false
    };
  },
  props: {
    experience: Object
  },
  methods: {
    openDialog() {
      this.isOpen = true;
    },
    closeDialog() {
      this.isOpen = false;
    }
  }
};
</script>
